// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


/** See com.rev360.pms.api.controller.accounting.FamilyRefundRequest */
/* istanbul ignore next */
@GandalfModel
export class FamilyRefundRequest extends GandalfModelBase {

	@GandalfLabel('Amount')
	@GandalfValidator({ moneyConstraints: { positiveAllowed: true, zeroAllowed: true, negativeAllowed: false, message: 'Amount cannot be negative' } })
	@GandalfValidator({ notNull: { message: 'Amount is required' } })
	@GandalfProperty({ propertyType: 'Money', designType: Number, isRequired: true })
	amount!: number;

	@GandalfLabel('Family Member')
	@GandalfValidator({ notNull: { message: 'Family Member is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	familyMemberPatientId!: number;

	@GandalfLabel('Location')
	@GandalfValidator({ notNull: { message: 'Location is required' } })
	@GandalfProperty({ designType: Number, isRequired: true })
	locationId!: number;

	@GandalfConstantDecorator(constants.RefundFrom)
	@GandalfLabel('Method')
	@GandalfValidator({ notNull: { message: 'Method is required' } })
	@GandalfProperty({ designType: constants.RefundFrom, isRequired: true })
	method!: constants.RefundFrom;

	@GandalfLabel('Ref #')
	@GandalfValidator({ sizeString: { message: 'Ref # cannot be longer than 50 characters', minLength: 0, maxLength: 50 } })
	@GandalfProperty({ designType: String })
	referenceNumber!: string | null;

}
